export default __webpack_public_path__ + "static/media/avatar12.61038d7e.svg";